import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./PageTitles.scss";

const PageTitles = ({ pageTitle, pageSubTitle, onClose }) => {
    return (
        <Box className="page-titles-container">
            <div className="title-wrapper">
                <Typography className="quency-cf-normal heading">
                    {pageTitle}
                </Typography>
                <div className="subtitle">
                    {pageSubTitle}
                </div>
            </div>
            {onClose && (
                <IconButton
                    className="closeButton"
                    onClick={onClose}
                    aria-label="close"
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            )}
        </Box>
    );
};
export default PageTitles;
